import React, { PureComponent } from 'react'
import parse from 'html-react-parser';
import { getModalsBySlug } from '../../../services/reservoir'
import { CustomModal } from './Modal'

export default class DrupalModal extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      title: '',
      content: ''
    }
  }

  componentDidMount() {
    this.loadModal(this.props)
  }

  componentDidUpdate(nextProps) {
    if (this.props.slug !== nextProps.slug) {
      this.loadModal(nextProps)
    }
  }

  loadModal = props => {
    getModalsBySlug(props.slug)
      .then(modals => modals.data)
      .then(modals => {
        if (modals.length > 0) {
          const modal = modals[0]

          this.setState({
            title: modal.attributes.title,
            content: modal.attributes.body.value
          })
        }
      })
  }

  render() {
    return (
      <CustomModal
        className={`modal ${this.props.className}`}
        isOpen={this.props.isOpen}
        handleCloseModal={() => this.props.handleCloseModal()}
        title={this.state.title}
        userCanClose={this.props.userCanClose}
      >
        {parse(this.state.content)}
      </CustomModal>
    )
  }
}
